import { render, staticRenderFns } from "./users-answer.vue?vue&type=template&id=2d52556d&lang=pug"
import script from "./users-answer.vue?vue&type=script&lang=js"
export * from "./users-answer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports